export enum FROM_LOCATION {
  sms = 'sms',
  login = 'login',
  loyaltyCreate = 'loyaltyCreate',
  create = 'create',
  createAccountCheckout = 'createAccountCheckout',
  showAccountBenefits = 'showAccountBenefits',
  legacyLogin = 'legacyLogin',
  emailDetected = 'emailDetected',
  loginFaster = 'loginFaster'
}

export enum SEARCH_PARAMS {
  resetFrom = 'resetFrom'
}
